import { PlusIcon } from "@heroicons/react/20/solid";
import cx from "../utils/cx.ts";
import { Maybe } from "../utils/types/maybe.ts";

type Props = {
  tabs: {
    name: string;
    isSelected: boolean;
    onSelected: () => void;
  }[];
  actions: Maybe<
    {
      label: string;
      onClick: () => void;
    }[]
  >;
};

export default function TabbedHeader({ tabs, actions }: Props) {
  return (
    <div className="flex flex-row justify-between items-end gap-12">
      <div className="border-b border-gray-200 flex-1">
        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <a
              key={tab.name}
              aria-current={tab.isSelected ? "page" : undefined}
              className={cx(
                tab.isSelected
                  ? "border-sky-500 text-sky-600"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                "whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium hover:cursor-pointer",
              )}
              onClick={tab.onSelected}
            >
              {tab.name}
            </a>
          ))}
        </nav>
      </div>
      {actions != null && (
        <div className="w-[200px] flex flex-row justify-end">
          {actions.map((action, index) => (
            <button
              key={index}
              type="button"
              className="inline-flex items-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
              onClick={action.onClick}
            >
              <PlusIcon className="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
